// src/enums/brazilian-uf.enum.ts
var BRAZILIAN_UF_VALUES = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO"
];
var BRAZILIAN_UF_LIST = [
  { id: "AC", text: "Acre" },
  { id: "AL", text: "Alagoas" },
  { id: "AP", text: "Amap\xE1" },
  { id: "AM", text: "Amazonas" },
  { id: "BA", text: "Bahia" },
  { id: "CE", text: "Cear\xE1" },
  { id: "DF", text: "Distrito Federal" },
  { id: "ES", text: "Esp\xEDrito Santo" },
  { id: "GO", text: "Goi\xE1s" },
  { id: "MA", text: "Maranh\xE3o" },
  { id: "MT", text: "Mato Grosso" },
  { id: "MS", text: "Mato Grosso do Sul" },
  { id: "MG", text: "Minas Gerais" },
  { id: "PA", text: "Par\xE1" },
  { id: "PB", text: "Para\xEDba" },
  { id: "PR", text: "Paran\xE1" },
  { id: "PE", text: "Pernambuco" },
  { id: "PI", text: "Piau\xED" },
  { id: "RJ", text: "Rio de Janeiro" },
  { id: "RN", text: "Rio Grande do Norte" },
  { id: "RS", text: "Rio Grande do Sul" },
  { id: "RO", text: "Rond\xF4nia" },
  { id: "RR", text: "Roraima" },
  { id: "SC", text: "Santa Catarina" },
  { id: "SP", text: "S\xE3o Paulo" },
  { id: "SE", text: "Sergipe" },
  { id: "TO", text: "Tocantins" }
];
var BRAZILIAN_UF_NAMES = {
  AC: "Acre",
  AL: "Alagoas",
  AP: "Amap\xE1",
  AM: "Amazonas",
  BA: "Bahia",
  CE: "Cear\xE1",
  DF: "Distrito Federal",
  ES: "Esp\xEDrito Santo",
  GO: "Goi\xE1s",
  MA: "Maranh\xE3o",
  MT: "Mato Grosso",
  MS: "Mato Grosso do Sul",
  MG: "Minas Gerais",
  PA: "Par\xE1",
  PB: "Para\xEDba",
  PR: "Paran\xE1",
  PE: "Pernambuco",
  PI: "Piau\xED",
  RJ: "Rio de Janeiro",
  RN: "Rio Grande do Norte",
  RS: "Rio Grande do Sul",
  RO: "Rond\xF4nia",
  RR: "Roraima",
  SC: "Santa Catarina",
  SP: "S\xE3o Paulo",
  SE: "Sergipe",
  TO: "Tocantins"
};

// src/enums/price-table-status.enum.ts
var PriceTableStatus = /* @__PURE__ */ ((PriceTableStatus2) => {
  PriceTableStatus2["ACTIVE"] = "ACTIVE";
  PriceTableStatus2["INACTIVE"] = "INACTIVE";
  PriceTableStatus2["CANCELLED"] = "CANCELLED";
  PriceTableStatus2["AWAITING_PUBLICATION"] = "AWAITING_PUBLICATION";
  PriceTableStatus2["DRAFT"] = "DRAFT";
  PriceTableStatus2["PAUSED"] = "PAUSED";
  return PriceTableStatus2;
})(PriceTableStatus || {});
var PRICE_TABLE_STATUS_LABELS = {
  ["ACTIVE" /* ACTIVE */]: "Ativa",
  ["INACTIVE" /* INACTIVE */]: "Inativa",
  ["CANCELLED" /* CANCELLED */]: "Cancelada",
  ["AWAITING_PUBLICATION" /* AWAITING_PUBLICATION */]: "Aguardando Publica\xE7\xE3o",
  ["DRAFT" /* DRAFT */]: "Rascunho",
  ["PAUSED" /* PAUSED */]: "Pausada"
};
export {
  BRAZILIAN_UF_LIST,
  BRAZILIAN_UF_NAMES,
  BRAZILIAN_UF_VALUES,
  PRICE_TABLE_STATUS_LABELS,
  PriceTableStatus
};
//# sourceMappingURL=index.js.map